export default __webpack_public_path__ + "static/media/skills-dark.c905157b.svg";